/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCircuitGround = createReactComponent("outline", "circuit-ground", "IconCircuitGround", [["path", { "d": "M12 13v-8", "key": "svg-0" }], ["path", { "d": "M4 13h16", "key": "svg-1" }], ["path", { "d": "M7 16h10", "key": "svg-2" }], ["path", { "d": "M10 19h4", "key": "svg-3" }]]);

export { IconCircuitGround as default };
//# sourceMappingURL=IconCircuitGround.mjs.map
